export default {
  suppliesInfo: {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 30px 0px',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    textAlign: 'justify'
  }
};
